import { createReducer, Action, on } from '@ngrx/store';

import * as LegalStandardActions from './legal-standard.actions';
import { LegalStandardState } from '../models/legal-standard.model';

const reducer = createReducer<LegalStandardState>(
  {},
  on(
    LegalStandardActions.setFertilizationLegalStandards,
    (state, { fertilizationLegalStandards }) => ({ ...state, fertilizationLegalStandards }),
  ),
);

export const legalStandardReducer = (state: LegalStandardState | undefined, action: Action) =>
  reducer(state, action);
